// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"493":"bf5f3635","912":"d279225f"}[chunkId] || chunkId) + "." + {"245":"f230c564cef687aa","493":"f49c4872e2155e52","534":"d6bc755c5bcdbcf0","912":"fc161ea04f605db1"}[chunkId] + ".js";
};